
import {
  defineComponent, ref, watch,onMounted, onUnmounted,
} from 'vue';
import moment from 'moment';
import * as echarts from 'echarts';
import { assetsImg, } from '@/configs';
import { postRequest, } from '@/request/request';

const { mockCarama, } = assetsImg;

export default defineComponent({
  props: {
    theme: {
      type: String,
      default: '',
      requir: true,
    },
    popupData: {
      type: Object,
      default: () => ({}),
      requir: true,
    },
  },
  setup (props,{ emit, }) {
    const indexLists = {
      tsp: {
        label: 'TSP',
        value: '78',
      },
      pm25: {
        label: 'PM₂.₅',
        value: '11',
      },
      pm10: {
        label: 'PM₁₀',
        value: '7',
      },
    };

    const checked = ref<string>('density');
    let historyData:any = [];

    let chart :any = null;

    const option = {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        y: '20px',
        x: '50px',
        // 高度
        height: '62%',
      },
      xAxis: {
        // 隐藏刻度线
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#000',
            fontSize: '12',
          },
        },
        data: {},
      },
      yAxis: {
        type: 'value',
        // 隐藏y轴
        axisLine: {
          show: false,
        },
        // 隐藏刻度线
        axisTick: {
          show: false,
        },
        //  网格线设置
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#000',
            opacity: '0.3',
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            fontSize: '12',
            color: '#000',
          },
        },
      },
      visualMap: {
        show: false,
        pieces: [
          {
            lte: 0,
            color: 'blue',
          },
          {
            gt: 0,
            lte: 1,
            color: '#f4ea2a',
          },
          {
            gt: 1,
            color: '#d81e06',
          },
        ],
        outOfRange: {
          color: '#999',
        },
      },
      series: {
        type: 'line',
        showSymbol: false,
        data: {},
        // data: data.map((item:any) => item.density),
      },
    };

    const changeRankingVisable = () => {
      emit('close');
    };

    const reSize = (): any => {
      if (chart) {
        chart.resize();
      }
    };

    const initCharts = () => {
      const container = document.getElementById('cons-chart') as HTMLElement;

      chart = echarts.init(container);
      window.addEventListener('resize', reSize);
    };

    // 绘制柱状图
    const setChart = (val: any) => {
      setTimeout(() => {
        if (chart) {
          chart.setOption(val);
        }
      }, 1000);
    };

    const handleHistoryChange = (val:string) => {
      checked.value = val;
      option.xAxis.data = historyData.map((item:any) => moment(item.dataTime, 'YYYYMMDDHH').format('HH'));
      option.series.data = historyData.map((item:any) => item[val]);
      setChart(option);
    };

    const getData = (val:any) => {
      const { constructionId, } = val || {};

      const params = {
        constructionId,
        endTime: '2022052518',
        startTime: '2022052512',
      };

      postRequest('/gaochun/airMap/constructionInfo',params).then((res:any) => {
        historyData = res.data;
      });
    };

    watch(() => props.popupData,(cur) => {
      if (Object.keys(cur)) {
        getData(cur);
      //  handleHistoryChange(checked.value);
      }
    },{ immediate: true, });

    onMounted(() => {
      initCharts();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', reSize);
      echarts.dispose(chart);
      chart = null;
    });

    return {
      moment,
      indexLists,
      mockCarama,
      changeRankingVisable,
      handleHistoryChange,
    };
  },
});
